import { Component } from "react";
import styles from "./information-block.module.less";
import { graphql } from "gatsby";

import LinkWrapper from "components/block-elements/link-wrapper/link-wrapper";
import RichTextRenderer from "components/block-elements/rich-text-renderer/rich-text-renderer";

import SiteConfigurationStore from "components/stores/site-configuration-store";
import { extract, Icon } from "@parksandresorts/core";

export default class InformationBlock extends Component {
  constructor(props) {
    super(props);

    this.title = extract(props, "title");
    this.infoPreamble = extract(props, "infoPreamble", null);
    this.informationType = extract(props, "informationType");
    this.link = extract(props, "link.internalLink.slug");
    this.icon = extract(props, "icon.file.url");
    this.readMoreLabel = SiteConfigurationStore.getLabel("READ_MORE");
  }

  render() {
    return (
      <>
        <section
          className="block block--padded block--max-width-narrow block--floating"
          data-contentful-id={this.props.contentful_id}
        >
          <LinkWrapper url={this.link ? this.link : undefined}>
            <div className={[styles.informationBlock, styles[this.informationType]].join(" ")}>
              <div className={styles.informationBlock__iconAndTextWrapper}>
                {this.icon && <img className={styles.informationBlock__icon} src={this.icon} alt="" />}
                <div className={styles.informationBlock__textWrapper}>
                  {this.props.title && <h4 className={styles.informationBlock__title}>{this.title}</h4>}
                  {this.infoPreamble !== null && (
                    <div className={[styles.informationBlock__text].join(" ")}>
                      <RichTextRenderer richTextData={this.infoPreamble} />
                    </div>
                  )}
                </div>
              </div>
              {this.link && (
                <div className={styles.informationBlock__linkText}>
                  <span className={styles.text}>{this.readMoreLabel}</span>{" "}
                  <Icon name="arrow-right" className={styles.icon} size="l" />
                </div>
              )}
            </div>
          </LinkWrapper>
        </section>
      </>
    );
  }
}

export const fragmentInformationBlock = graphql`
  fragment InformationBlock on ContentfulInformationBlock {
    ... on ContentfulInformationBlock {
      contentful_id
      id
      title
      infoPreamble {
        raw
      }
      informationType
      icon {
        file {
          url
        }
      }
      link {
        ...Link
      }
    }
  }
`;
